// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Help_wrapper__X9PeF {
  padding-bottom: 50px;
  padding-top: 50px;
}
.Help_wrapper__X9PeF .Help_title__veT2b {
  font-size: 48px;
  font-weight: 700;
  font-style: normal;
  color: #FFFFFF;
  margin-bottom: 24px;
  text-align: center;
}
.Help_wrapper__X9PeF .Help_txt__XUVnJ {
  font-size: 20px;
  font-weight: 400;
  font-style: normal;
  color: #E0E0E0;
  margin-bottom: 8px;
  text-align: center;
}
.Help_wrapper__X9PeF .Help_social__4Jxe3 {
  display: flex;
  gap: 20px;
  justify-content: center;
  margin-top: 32px;
}
.Help_wrapper__X9PeF .Help_social__4Jxe3 .Help_tg__8S\\+PR {
  align-items: center;
  background-color: #19334F;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  height: 56px;
  transition: all 0.2s linear;
  width: 64px;
}
.Help_wrapper__X9PeF .Help_social__4Jxe3 .Help_tg__8S\\+PR:hover {
  background-color: #244971;
}
.Help_wrapper__X9PeF .Help_social__4Jxe3 .Help_phone__BaKtt {
  align-items: center;
  background-color: #3A2159;
  border-radius: 8px;
  color: #AE6FFF;
  display: flex;
  gap: 8px;
  justify-content: center;
  height: 56px;
  transition: all 0.2s linear;
  width: auto;
  padding: 10px;
}
.Help_wrapper__X9PeF .Help_social__4Jxe3 .Help_phone__BaKtt:hover {
  background-color: #4A2C6F;
}
.Help_wrapper__X9PeF .Help_back__W5HSf {
  cursor: pointer;
  left: 24px;
  position: absolute;
  top: 32px;
  transition: all 0.2s linear;
}
.Help_wrapper__X9PeF .Help_back__W5HSf:hover path {
  fill: #ffffff;
}

@media (max-width: 850px) {
  .Help_wrapper__X9PeF .Help_title__veT2b {
    font-size: 32px;
  }
  .Help_wrapper__X9PeF .Help_txt__XUVnJ {
    font-size: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/modals/Help/Help.module.scss","webpack://./src/assets/styles/_fonts.scss"],"names":[],"mappings":"AAEA;EACE,oBAAA;EACA,iBAAA;AADF;AAGE;ECCA,eAAA;EACA,gBAAA;EACA,kBAAA;EDAE,cAAA;EACA,mBAAA;EACA,kBAAA;AAAJ;AAGE;EC6BA,eAAA;EACA,gBAAA;EACA,kBAAA;ED5BE,cAAA;EACA,kBAAA;EACA,kBAAA;AAAJ;AAGE;EACE,aAAA;EACA,SAAA;EACA,uBAAA;EACA,gBAAA;AADJ;AAGI;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,YAAA;EACA,2BAAA;EACA,WAAA;AADN;AAGM;EACE,yBAAA;AADR;AAKI;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,QAAA;EACA,uBAAA;EACA,YAAA;EACA,2BAAA;EACA,WAAA;EACA,aAAA;AAHN;AAKM;EACE,yBAAA;AAHR;AAQE;EACE,eAAA;EACA,UAAA;EACA,kBAAA;EACA,SAAA;EACA,2BAAA;AANJ;AAQI;EACE,aAAA;AANN;;AAWA;EAGI;IACE,eAAA;EAVJ;EAaE;IACE,eAAA;EAXJ;AACF","sourcesContent":["@import '../../../assets/styles/global.scss';\n\n.wrapper {\n  padding-bottom: 50px;\n  padding-top: 50px;\n\n  .title {\n    @include h2;\n\n    color: #FFFFFF;\n    margin-bottom: 24px;\n    text-align: center;\n  }\n\n  .txt {\n    @include subtitle5;\n\n    color: #E0E0E0;\n    margin-bottom: 8px;\n    text-align: center;\n  }\n\n  .social {\n    display: flex;\n    gap: 20px;\n    justify-content: center;\n    margin-top: 32px;\n\n    .tg {\n      align-items: center;\n      background-color: #19334F;\n      border-radius: 8px;\n      display: flex;\n      justify-content: center;\n      height: 56px;\n      transition: all .2s linear;\n      width: 64px;\n\n      &:hover {\n        background-color: #244971;\n      }\n    }\n\n    .phone {\n      align-items: center;\n      background-color: #3A2159;\n      border-radius: 8px;\n      color: #AE6FFF;\n      display: flex;\n      gap: 8px;\n      justify-content: center;\n      height: 56px;\n      transition: all .2s linear;\n      width: auto;\n      padding: 10px;\n\n      &:hover {\n        background-color: #4A2C6F;\n      }\n    }\n  }\n\n  .back {\n    cursor: pointer;\n    left: 24px;\n    position: absolute;\n    top: 32px;\n    transition: all .2s linear;\n\n    &:hover path {\n      fill: #ffffff;\n    }\n  }\n}\n\n@media (max-width: 850px) {\n  .wrapper {\n    \n    .title {\n      font-size: 32px;\n    }\n\n    .txt {\n      font-size: 16px;\n    }\n  }\n}","@mixin h1 {\n  font-size: 64px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h2 {\n  font-size: 48px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h3 {\n  font-size: 32px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle1b {\n  font-size: 24px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle2m {\n  font-size: 24px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle3b {\n  font-size: 20px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle4m {\n  font-size: 20px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle5 {\n  font-size: 20px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin subtitle6m {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle7m {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin body1 {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin body2 {\n  font-size: 14px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin buttonlarge {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonmedium {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonsmall {\n  font-size: 13px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin input {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin helper {\n  font-size: 12px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin tableinput {\n  font-size: 13px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `Help_wrapper__X9PeF`,
	"title": `Help_title__veT2b`,
	"txt": `Help_txt__XUVnJ`,
	"social": `Help_social__4Jxe3`,
	"tg": `Help_tg__8S+PR`,
	"phone": `Help_phone__BaKtt`,
	"back": `Help_back__W5HSf`
};
export default ___CSS_LOADER_EXPORT___;
